var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ1TopDownArrowC(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 58.37V17.66L22.63 31H17l21-21 21 21h-5.63L40 17.65v40.72L53.37 45H59L38 66 17 45h5.63L36 58.37z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J1_Top-down_arrow_C.f2daab06.svg";
export { SvgJ1TopDownArrowC as ReactComponent };